import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogueHandler, EditSignerDialogueHandler } from './types';
import EditSignerContext from './EditSignerContext';

const { ConfirmationDialogue } = vp;

type EditSignerDialogueProps = {
  handleDialogue: DialogueHandler<EditSignerDialogueHandler>;
};

type FC = FunctionComponent<EditSignerDialogueProps>;

const EditSignerDialogue: FC = ({ handleDialogue }: EditSignerDialogueProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'EditSignerDialogue' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const { showEditSignerErrorAlert } = useContext(EditSignerContext);

  return useMemo(
    () => (
      <div>
        {/* Edit Signer Error */}
        <ConfirmationDialogue
          isVisible={showEditSignerErrorAlert}
          title={t('title', { defaultValue: 'Error! The signer was not edited.' })}
          status="error"
          subTitle={t('subTitle', { defaultValue: 'Please provide valid address.' })}
          confirm={{
            label: tGlobal('Buttons.back'),
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [showEditSignerErrorAlert, t, tGlobal],
  );
};

export default EditSignerDialogue;
